import translation from 'translation';

export function getResourcesSorts(sortType) {
  const { t } = translation;

  const byFollower = {
    sortType: sortType || 'desc',
    value: 'follower_count',
    label: sortType ? t('filter:followerCount') : t('filter:maxFollowerCount'),
  };

  const byPost = {
    sortType: sortType || 'desc',
    value: 'post_count',
    label: sortType ? t('filter:contentCount') : t('filter:maxContentCount'),
  };

  const byMember = {
    sortType: sortType || 'desc',
    value: 'member_count',
    label: sortType ? t('filter:memberCount') : t('filter:maxMemberCount'),
  };

  const sorts = {
    instagram: [byFollower, byPost],
    telegram: [byMember, byPost],
    twitter: [byFollower, byPost],
    virasty: [byFollower, byPost],
    linkedin: [],
    nativePlatforms: [byMember],
    bale: [byMember],
    eitaa: [byMember],
    rubika: [byMember],
    news: [],
    newspaper: [],
  };

  return sorts;
}
